import script from "./editableField.vue?vue&type=script&setup=true&lang=ts"
export * from "./editableField.vue?vue&type=script&setup=true&lang=ts"

import "./editableField.vue?vue&type=style&index=0&id=fe9b2b14&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe9b2b14"]])

export default __exports__